// eslint-disable-next-line no-restricted-imports
import {
  LegalClientBranchFragment,
  Query_LegalClientBranchController_GetById_Status,
} from 'api/generated/graphql';
import { LegalClientBranchEntity } from 'api/types/entity';
import { lodash } from 'helpers';

import { parseFileDocumentEntity } from '../client/parseEntity/parseFileEntity';
import { parseLegalClientTaxResidency } from '../legal/parseEntity/parseLegalClientTaxResidency';
import { parseOboardingData } from '../parseOboardingData';

import {
  parseLegalClientBranchContacts,
  parseLegalClientBranchStateRegistration,
} from './parseEntity';

export const parseLegalClientBranchEntity = (
  data: LegalClientBranchFragment
): LegalClientBranchEntity => ({
  id: data.id,
  versionNumber: data.version?.number,
  versionId: data.version?.id,
  createdAt: new Date(data.createdAt),
  deletedAt: data.deletedAt ? new Date(data.deletedAt) : undefined,
  archived:
    data.status === Query_LegalClientBranchController_GetById_Status.Archived,
  fullName: data.fullName,
  legalClientId: data.legalClientId || undefined,
  onboarding: parseOboardingData(data.onboarding),
  actualAddress: data.actualAddress,
  legalAddress: data.legalAddress,
  taxResidences: data.taxResidences
    ? lodash.compact(data.taxResidences).map(parseLegalClientTaxResidency)
    : undefined,
  stateRegistration: parseLegalClientBranchStateRegistration(
    data.stateRegistration
  ),
  contacts: parseLegalClientBranchContacts(data.contacts),
  additionalInformationFiles: lodash
    .compact(data.additionalInformationDocuments)
    .map(parseFileDocumentEntity),
});
